export const PERIOD_EVOLUTIONS = [
    'date_key_evolution_date',
    'date_key_evolution_week',
    'date_key_evolution_month',
    'period_code_evolution'
];
//# sourceMappingURL=periodEvolutions.constant.js.map